/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react'
import classNames from 'classnames'
import { Icon } from '@iconify/react'
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles'
import Grow from '@material-ui/core/Grow'
import Paper from '@material-ui/core/Paper'
import ClickAwayListener from '@material-ui/core/ClickAwayListener'
import Hidden from '@material-ui/core/Hidden'
import Poppers from '@material-ui/core/Popper'
import MenuItem from '@material-ui/core/MenuItem'
import MenuList from '@material-ui/core/MenuList'
// @material-ui/icons
import Person from '@material-ui/icons/Person'
// core components
import Button from '../../assets/jss/material-dashboard-react/CustomButtons/Button'
import styles from '../../assets/jss/material-dashboard-react/layout/headerLinksStyle'
import { useAuthentication } from '../../context/authenticationContext'
import usersService from '../../services/Admin/Users/UsersActions'
import _ from 'lodash'
import config from '../../config/config.json'
import ROUTES from '../../routers/routes'
import { useHistory } from 'react-router-dom'
import ModalRegisterMipymes from '../../pages/IFIS/RegistroMipymesIfis/ModalRegisterMipymes'
import { FormContextProvider } from '../../context/formContext'
import { ModalWorkshop } from '../../pages/Formularios/Workshop/ModalWorkshop/ModalWorkshop'
import ModalRegister from '../../pages/Formularios/RegistroMipymes/ModalRegister'
import MenuIcon from '@mui/icons-material/Menu'
import { Box, Modal, RadioGroup } from '@mui/material'
import {
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  Typography,
} from '@material-ui/core'
import { ModalConfirmation } from '../../pages/IFIS/RegistroMipymesIfis/ModalConfirmation'
import ModalChangeUserRegister from '../../pages/IFIS/ChangeUser/ModalChangeUserRegister'
// import { ModalConfirmationChange } from '../../pages/IFIS/ChangeUser/ModalConfirmation'

const useStyles = makeStyles(styles)

export default function AdminNavbarLinks() {
  const classes = useStyles()
  const { isAuthenticated, logout, UserRoles, userName } = useAuthentication()
  const [openProfile, setOpenProfile] = useState(null)
  const [Roles, setRoles] = useState(null)
  const [openWorkshop, setOpenWorkshop] = useState(false)
  const [open, setOpen] = useState(false)
  const [openModalChange, setOpenModalChange] = useState(false)
  const [userRegister, setUserRegister] = useState('')

  const handleClickProfile = (event) => {
    if (openProfile && openProfile.contains(event.target)) {
      setOpenProfile(null)
    } else {
      setOpenProfile(event.currentTarget)
    }
  }
  const handleCloseProfile = () => {
    setOpenProfile(null)
  }

  const handleClose = () => setOpen(false)
  const handleOpen = () => {
    setOpen(true)
  }

  const handleChangeUser = () => {
    setOpenModalChange(true)
  }

  useEffect(() => {
    if (UserRoles?.length > 0) {
      usersService.getRoles(config.REACT_APP_DOMAIN).then((result) => {
        if (result) {
          const { roles } = result
          const profile = _.reduce(
            roles,
            function (result, value, key) {
              if (_.includes(UserRoles, value.roleGroupId)) {
                ;(result.profile || (result.profile = [])).push(value.name)
              }
              return result
            },
            {},
          )
          setRoles(profile.profile)
        }
      })
    }
  }, [UserRoles])

  const history = useHistory()

  const handleToSolicitud = () => {
    history.push(ROUTES.REPRESENTARMIPYME.pathname)
  }
  const handleToNotificationSolicitud = () => {
    history.push(ROUTES.NOTIFICACIONIFIMIPYME.pathname)
  }

  const handleToRepresentacionSolicitud = () => {
    history.push(ROUTES.REPRESENTACIONMIPYME.pathname)
  }

  const handleOpenWorkshop = () => {
    setOpenWorkshop(true)
  }

  const handleToEliminarPresentacionMIPYME = () => {
    history.push(ROUTES.ELIMINARMIPYMESIFIS.pathname)
  }
  const handleToEliminarPresentacionIFI = () => {
    history.push(ROUTES.ELIMINARIFIMIPYMES.pathname)
  }
  const handleSolicitudWorkshop = () => {
    history.push(ROUTES.SOLICITUDWORKSHOP.pathname)
  }

  const handleQuestionnaire = () => {
    history.push(ROUTES.CUESTIONARIOMONITOREOYEVALUACIONLISTADO.pathname)
  }

  const handleActivationMIPYME = () => {
    history.push(ROUTES.ACTIVATIONMIPYME.pathname)
  }

  const [openRegister, setOpenRegister] = useState(false)
  const [openRegisterMipyme, setOpenRegisterMipyme] = useState(false)

  /* ::REGISTER:: */
  const handleOpenRegister = () => setOpenRegister(true)
  const handleCloseRegister = () => setOpenRegister(false)

  // Register MIPYME
  const handleOpenRegisterMipyme = () => setOpenRegisterMipyme(true)
  const handleCloseRegisterMipyme = () => setOpenRegisterMipyme(false)

  return (
    <>
      {UserRoles && UserRoles.includes('IFI') ? (
        <div className={classes.manager}>
          <Button
            color={window.innerWidth > 959 ? 'transparent' : 'info'}
            justIcon={window.innerWidth > 959}
            simple={!(window.innerWidth > 959)}
            aria-owns={openProfile ? 'profile-menu-list-grow' : null}
            aria-haspopup="true"
            onClick={handleClickProfile}
            className={classes.buttonLink}
          >
            <MenuIcon className={classes.icons} />

            <Hidden mdUp implementation="css">
              <p className={classes.linkText}>Usuario</p>
            </Hidden>
          </Button>
          <Poppers
            open={Boolean(openProfile)}
            anchorEl={openProfile}
            transition
            disablePortal
            className={
              classNames({ [classes.popperClose]: !openProfile }) +
              ' ' +
              classes.popperNav
            }
          >
            {({ TransitionProps, placement }) => (
              <Grow
                {...TransitionProps}
                id="profile-menu-list-grow"
                style={{
                  transformOrigin:
                    placement === 'bottom' ? 'center top' : 'center bottom',
                }}
              >
                <Paper>
                  <ClickAwayListener onClickAway={handleCloseProfile}>
                    <MenuList role="menu">
                      {isAuthenticated && (
                        <MenuItem className={classes.dropdownItem}>
                          <span>Usuario: {userName}</span>
                        </MenuItem>
                      )}
                      {/* <MenuItem className={classes.dropdownItem}>
                    {isAuthenticated && (
                      <>
                        <span>{userName}</span>
                      </>
                    )}
                  </MenuItem> */}
                      {/* {isAuthenticated && !Roles && UserRoles && (
                        <MenuItem className={classes.dropdownItem}>
                          {<span>Perfiles: {_.join(UserRoles, ', ')}</span>}
                        </MenuItem>
                      )} */}
                      {/* {isAuthenticated && <MenuItem>Perfiles: </MenuItem>} */}
                      {/* {isAuthenticated &&
                        Roles &&
                        UserRoles &&
                        Roles?.map(function (Name, i) {
                          return (
                            <MenuItem key={i} className={classes.dropdownItem}>
                              {Name}
                            </MenuItem>
                          )
                        })} */}

                      <MenuItem
                        className={classes.dropdownItem}
                        // onClick={() => handleOpenRegister()}
                        onClick={() => handleOpen()}
                      >
                        <span>Registrar MIPYME</span>
                      </MenuItem>

                      <MenuItem
                        className={classes.dropdownItem}
                        onClick={() => handleToNotificationSolicitud()}
                      >
                        <span>Representar MIPYME</span>
                      </MenuItem>
                      <MenuItem
                        className={classes.dropdownItem}
                        onClick={() => handleToRepresentacionSolicitud()}
                      >
                        <span>MIPYME Representadas</span>
                      </MenuItem>
                      <MenuItem
                        className={classes.dropdownItem}
                        onClick={() => handleChangeUser()}
                      >
                        <span>Cambiar Usuario</span>
                      </MenuItem>
                      <MenuItem
                        className={classes.dropdownItem}
                        onClick={() => handleActivationMIPYME()}
                      >
                        <span>Activación MIPYME</span>
                      </MenuItem>
                      <MenuItem
                        className={classes.dropdownItem}
                        onClick={() => handleToEliminarPresentacionMIPYME()}
                      >
                        <span>Eliminar Representación</span>
                      </MenuItem>
                      <MenuItem
                        className={classes.dropdownItem}
                        onClick={() => handleSolicitudWorkshop()}
                      >
                        <span>Seguimiento Taller Inicial</span>
                      </MenuItem>
                      <MenuItem
                        className={classes.dropdownItem}
                        onClick={() => handleQuestionnaire()}
                      >
                        <span> Cuestionario Monitoreo y Evaluación</span>
                      </MenuItem>

                      {/* <MenuItem
                        className={classes.dropdownItem}
                        onClick={() => handleToRegister()}
                      >
                        <span>Solicitar Workshop</span>
                      </MenuItem>
                      <MenuItem
                        className={classes.dropdownItem}
                        onClick={() => handleToRegister()}
                      >
                        <span>Asignar Préstamo</span>
                      </MenuItem> */}
                      <MenuItem className={classes.dropdownItem}>
                        {isAuthenticated && (
                          <>
                            <Icon icon="codicon:bell-dot" height="24" />

                            <span onClick={logout}> Cerrar Sesión</span>
                          </>
                        )}
                      </MenuItem>
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Poppers>
          <FormContextProvider>
            <ModalRegisterMipymes
              open={openRegister}
              handleClose={() => handleCloseRegister()}
            />
            <ModalConfirmation
              open={open}
              setOpen={setOpen}
              setOpenRegister={setOpenRegister}
            />
            <ModalChangeUserRegister
              open={openModalChange}
              setOpen={setOpenModalChange}
            />
            {/* <ModalConfirmationChange
              open={openModalChange}
              setOpen={setOpenModalChange}
            /> */}

            {/* <Modal
              open={open}
              onClose={handleClose}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
              disableEnforceFocus
            >
              <Box sx={style}>
                <Typography id="modal-modal-title" variant="h6" component="h2">
                  Registro de MIPYME
                </Typography>
                <Grid container spacing={1} className="input__container">
                  <Grid item xs={12} sm={12} md={12}>
                    <label className="responsiveLabel">
                      ¿Que tipo de usuario registrará?{' '}
                    </label>
                  </Grid>
                  <Grid item xs={12} sm={12} md={12}>
                    <FormControl style={{ width: '100%' }}>
                      <RadioGroup
                        id="IsNativeCommunity"
                        aria-labelledby="demo-radio-buttons-group-label"
                        name="radio-buttons-group"
                        onChange={(e) => {
                          handleChangeRegister(e)
                        }}
                        value={userRegister}
                      >
                        <FormControlLabel
                          value="newUser"
                          control={<Radio />}
                          label="Usuario nuevo"
                        />
                        <FormControlLabel
                          value="RegisterUser"
                          control={<Radio />}
                          label="Usuario registrado"
                        />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                  <Grid className="buttonsPYME">
                    <Button
                      className="cancelButton"
                      onClick={() => handleClose()}
                    >
                      Cancelar
                    </Button>
                    <Button
                      className="confirmButton"
                      type="button"
                      // onClick={validateFormStatus}
                      // disabled={loading}
                    >
                      Confirmar
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            </Modal> */}
          </FormContextProvider>
        </div>
      ) : (
        <div className={classes.manager}>
          <Button
            color={window.innerWidth > 959 ? 'transparent' : 'info'}
            justIcon={window.innerWidth > 959}
            simple={!(window.innerWidth > 959)}
            aria-owns={openProfile ? 'profile-menu-list-grow' : null}
            aria-haspopup="true"
            onClick={handleClickProfile}
            className={classes.buttonLink}
          >
            <MenuIcon className={classes.icons} />
            <Hidden mdUp implementation="css">
              <p className={classes.linkText}>Usuario</p>
            </Hidden>
          </Button>
          <Poppers
            open={Boolean(openProfile)}
            anchorEl={openProfile}
            transition
            disablePortal
            className={
              classNames({ [classes.popperClose]: !openProfile }) +
              ' ' +
              classes.popperNav
            }
          >
            {({ TransitionProps, placement }) => (
              <Grow
                {...TransitionProps}
                id="profile-menu-list-grow"
                style={{
                  transformOrigin:
                    placement === 'bottom' ? 'center top' : 'center bottom',
                }}
              >
                <Paper>
                  <ClickAwayListener onClickAway={handleCloseProfile}>
                    <MenuList role="menu">
                      {isAuthenticated && (
                        <MenuItem className={classes.dropdownItem}>
                          <span>Usuario: {userName}</span>
                        </MenuItem>
                      )}
                      {/* <MenuItem className={classes.dropdownItem}>
                    {isAuthenticated && (
                      <>
                        <span>{userName}</span>
                      </>
                    )}
                  </MenuItem> */}

                      {/* {isAuthenticated && <MenuItem>Perfiles: </MenuItem>} */}
                      {isAuthenticated &&
                        Roles &&
                        UserRoles &&
                        Roles?.map(function (Name, i) {
                          return (
                            <MenuItem key={i} className={classes.dropdownItem}>
                              {Name}
                            </MenuItem>
                          )
                        })}

                      <MenuItem
                        className={classes.dropdownItem}
                        onClick={() => handleOpenRegisterMipyme()}
                      >
                        <span>Registrar MIPYME</span>
                      </MenuItem>
                      <MenuItem
                        className={classes.dropdownItem}
                        onClick={() => handleToRepresentacionSolicitud()}
                      >
                        <span>MIPYME administradas</span>
                      </MenuItem>
                      <MenuItem
                        className={classes.dropdownItem}
                        onClick={() => handleToSolicitud()}
                      >
                        <span>Gestión de representación IFI</span>
                      </MenuItem>
                      <MenuItem
                        className={classes.dropdownItem}
                        onClick={() => handleOpenWorkshop()}
                      >
                        <span>Taller Inicial</span>
                      </MenuItem>
                      <MenuItem
                        className={classes.dropdownItem}
                        onClick={() => handleToEliminarPresentacionIFI()}
                      >
                        <span>Eliminar Representación</span>
                      </MenuItem>
                      {/* <MenuItem
                        className={classes.dropdownItem}
                        onClick={() => handleToRegister()}
                      >
                        <span>Gestionar Usuarios</span>
                      </MenuItem> */}
                      <MenuItem className={classes.dropdownItem}>
                        {isAuthenticated && (
                          <>
                            <Icon icon="codicon:bell-dot" height="24" />

                            <span onClick={logout}> Cerrar Sesión</span>
                          </>
                        )}
                      </MenuItem>
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Poppers>
          <ModalWorkshop open={openWorkshop} setOpen={setOpenWorkshop} />
          <FormContextProvider>
            <ModalRegister
              open={openRegisterMipyme}
              setOpen={setOpenRegisterMipyme}
              handleClose={() => handleCloseRegisterMipyme()}
            />
          </FormContextProvider>
        </div>
      )}
    </>
  )
}
